import { IResultados } from "../interfaces/Resultados";
import { getQueryParameter } from "../util/helpers";
import { get } from "./fetch";

//Resultados son Logros

export const getData = async (code?: string) => {
  //Stored Procedure: DashboardSituacion_Get_Resultados OP:2
  var result = await get(code ? `/api/resultados/${code}` : `/api/resultados`);
  return result;
};

export const index = async () => {
  //Stored Procedure: DashboardSituacion_Get_Resultados OP:1
  var result = await get(`/api/resultados`);
  return result;
};

export const getResultDataFiltered = async(queryParams?:{
  paisId?:string, 
  palabraClave?:number,
  idioma?:string}): Promise<IResultados[]> => {
    let queryString = getQueryParameter(queryParams);
    var result:IResultados[] = await get(`/api/resultados${queryString}`);
    return result;
  }